import styled from 'styled-components'

export const SortableItemWrapper = styled.div`
    position: relative;
`
